module.exports = __webpack_public_path__ + "img/lasource-27.6ede8f83.jpg";